// given that the main grid is virtualized, job card containers will be removed
// from the DOM once they go off the viewable area. intent with these dummy
// columns is to enlarge the viewable area and hide them behind the drivers
// list, which will prevent job cards from disappearing.
const DUMMY_COLUMNS_COUNT = 2;

const generateHours = () => {
  const hours = Array.from({ length: DUMMY_COLUMNS_COUNT }, () => '');

  for (let i = 0; i < 24; i++) {
    const hour = i % 12 === 0 ? 12 : i % 12;
    const period = i < 12 ? 'AM' : 'PM';
    hours.push(`${hour} ${period}`);
  }

  return hours;
};
export const HOURS = generateHours();
export const FULL_HOUR_WIDTH = 80;
export const DUMMY_COLUMNS_SIZE = DUMMY_COLUMNS_COUNT * FULL_HOUR_WIDTH;
export const INCREMENTS_PER_HOUR = 4;
export const DUMMY_COLUMN_INCREMENTS = DUMMY_COLUMNS_COUNT * INCREMENTS_PER_HOUR;
export const MINUTES_PER_INCREMENT = 60 / INCREMENTS_PER_HOUR;
export const GRID_ITEM_WIDTH = FULL_HOUR_WIDTH / INCREMENTS_PER_HOUR;
export const HEADER_HEIGHT = 110;
export const ROW_HEIGHT = 80;
export const JOB_COLUMN_WIDTH = 300;
export const JOB_WIDTH = 274;
export const STICKY_HEADER_HEIGHT = 120;
export const JOB_CARD_OFFSET = 230;
export const APPBAR_HEIGHT_IN_PX = 65;
// when the grid is scrolled to the far right, some hour columns will not be visible
// in the grid's viewport. we need to hardcode that number here, since we need to know
// beforehand how many columns are to be overscanned to avoid the job cards from
// dissapearing when the user scrolls the grid and the cards falls off the viewport.
const HOUR_COLUMNS_NOT_VISIBLE_WHEN_GRID_IS_SCROLLED_TO_THE_FAR_RIGHT = 10;
export const OVERSCAN_COLUMN_COUNT =
  HOUR_COLUMNS_NOT_VISIBLE_WHEN_GRID_IS_SCROLLED_TO_THE_FAR_RIGHT * INCREMENTS_PER_HOUR;
export const MIN_CARD_WIDTH = 150;
export const INFINITE_SCROLL_THRESHOLD_PERCENTAGE = 0.9;
